import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import "./tailwind.generated.css";
import axios from "axios";
import { Card, Col, Row, Figure } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import dayjs from "dayjs";
import parse from "html-react-parser";
import Loader from "react-loader-spinner";
import FadeIn from "react-fade-in";
import { EmailShareButton, FacebookShareButton, FacebookIcon, EmailIcon } from "react-share";
import { useLocalStorage } from "./hooks/useLocalStorage";

import CustomCard from "./components/CustomCard";
import FilterSearchBar from "./components/FilterSearchBar";
import CustomPagination from "./components/CustomPagination";
import { swapUrlOrigin } from "./utils";

const animatedComponents = makeAnimated();

function App() {
  const el = document.getElementById("tto-events");
  const curCategory = el.getAttribute("data-category")
    ? [
        {
          value: parseInt(el.getAttribute("data-category")),
          label: el.getAttribute("data-cat-name"),
          count: 3,
        },
      ]
    : null;
  let loadedCurrent = false;
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [perPage, setPerPage] = useState(12);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageData, setCurrentPageData] = useState(0);
  const [pickedDate, setPickedDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(curCategory);
  const [searchTerm, setSearchTerm] = useState(null);
  const [addToFavorites, setAddToFavorites] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([{ value: 0, label: "All" }]);
  const [hearts, setHearts] = useState([]);
  const [localStorageEvent, setLocalStorageEvent] = useLocalStorage("events", []);
  const rootRef = useRef(null);

  const siteUrl =
    process.env.NODE_ENV === "development" ? "https://tempetourisdev.wpenginepowered.com" : window.location.origin;
  const offset = currentPage * perPage;

  const stripedExcerpt = (string) => {
    return string.replace(/<[^>]+>/g, "").replace(/&#8217;/g, "ˊ");
  };

  //CHECKS LOCAL FOR FIRST TIME - RESESTS IF RETURNING TO PAGE
  const firstTime = localStorage.getItem("first_time");
  if (currentPage == 0 && firstTime == "1") {
    localStorage.setItem("first_time", "0");
  }

  useEffect(() => {
    if (currentPage > 0 || firstTime == "1") {
      localStorage.setItem("first_time", "1");
      rootRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
    // window.scrollTo(0, 0);
  }, [currentPage]);

  //useEffect(() => {
  //  (async function () {
  //    if (filteredEvents[offset]?.id) {
  //      setIsLoading(true);
  //      const events = await getEventWithImages(filteredEvents.slice(offset, offset + perPage));
  //      const _filteredEvents = [...filteredEvents];
  //      _filteredEvents.splice(offset, events.length, ...events);
  //      setFilteredEvents(_filteredEvents);
  //      setIsLoading(false);
  //    }
  //  })();
  //}, [filteredEvents[offset]?.id]);

  useEffect(() => {
    const allIcons = document.getElementsByClassName("empty-hearth");
    // console.log(allIcons);
  }, []);

  // const filterEvents = () => {
  //     let curEvents = filterByCategory(events);
  // }

  const getData = async () => {
    const response = await axios.get(`${siteUrl}/wp-json/wp/v2/event?per_page=${65}&page=${currentPage + 1}`);
    const _events = [...(Array.isArray(response.data) ? response.data : [])];
    for (let i = 1; i < +response.headers["x-wp-totalpages"]; i++) {
      const res = await axios.get(`${siteUrl}/wp-json/wp/v2/event?per_page=${65}&page=${i + 1}`);
      if (Array.isArray(res.data)) _events.push(...res.data);
    }
    console.log("ALL EVENTS", _events);
    const data = _events.filter((event) => event.acf && parseInt(event.acf.ending_date) >= convertDate(new Date()));
    console.log("FILTERED EVENTS", data);

    let filtered = data.sort((a, b) => parseInt(a.acf?.ending_date) - parseInt(b.acf?.ending_date));
    //const today = convertDate(new Date());
    //let filtered = data.sort(
    //  (a, b) => Math.abs(parseInt(a.acf.starting_date) - today) - Math.abs(parseInt(b.acf.starting_date) - today),
    //);
    setEvents(data);

    // const orderData = response.data.sort((a, b) =>
    // 	Date.parse(a.tto_event_meta['start_date'].date) >=
    // 	Date.parse(b.tto_event_meta['start_date'].date)
    // 		? 1
    // 		: -1,
    // );

    if (curCategory) {
      filtered = data.filter((d) => {
        return d.event_category.includes(curCategory[0].value);
      });
    }

    setFilteredEvents(filtered);
  };

  //const getEventWithImages = async (events) => {
  //  const promises = events
  //    .filter((event) => !event.acf.single_header_images[0]?.image?.sizes)
  //    .map(async (event) => {
  //      const media = event._links["wp:featuredmedia"]?.[0]?.href;
  //      const eventImage = {};
  //      if (media) {
  //        const res = await axios.get(media).catch((err) => console.log(err));
  //        if (res.data.media_details?.sizes) {
  //          eventImage["large"] = res.data.media_details.sizes["large"]?.source_url;
  //          eventImage["medium_large"] = res.data.media_details.sizes["medium_large"]?.source_url;
  //          eventImage["medium"] = res.data.media_details.sizes["medium"]?.source_url;
  //        }
  //      }
  //      event.eventImage = eventImage;
  //      return event;
  //    });
  //  const eventsWithImages = await Promise.all(promises).catch((err) => {
  //    console.log(err);
  //    return events;
  //  });
  //  return eventsWithImages;
  //};

  const displayEvents = () => {
    setCurrentPageData([...filteredEvents.slice(offset, offset + perPage)]);
    setPageCount(Math.ceil(filteredEvents.length / perPage));
    //setTimeout(() => {
    // if (!loadedCurrent) {
    //     setSelectedCategory(curCategory);
    //     loadedCurrent = true;
    // }
    //setIsLoading(false);
    //}, 1500);
  };

  // event categories
  const getCategories = async () => {
    const res = await axios.get(`${siteUrl}/wp-json/wp/v2/event_category`);
    const data = res.data;
    setCategories(data);
    const selectOptions = data.map((option) => {
      return {
        value: option.id,
        label: parse(option.name),
        count: option.count,
      };
    });
    setOptions(selectOptions);
  };

  useEffect(() => {
    getSearchedEvents();
  }, [searchTerm]);

  useEffect(() => {
    getData().then(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    displayEvents();
  }, [filteredEvents]);

  useEffect(() => {
    getCategories();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    e.preventDefault?.();
  };

  const handlePageChange = (selectedObject) => {
    setCurrentPage(selectedObject.selected);
  };

  useEffect(() => {
    getEventsInCategory();
  }, [selectedCategory]);

  useEffect(() => {
    filterEventsByDate();
  }, [pickedDate]);

  //CONVERT DATE
  function convertDate(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return parseInt([date.getFullYear(), mnth, day].join(""));
  }

  const filterEventsByDate = () => {
    const _events = _filterEventsByCategory(events);
    if (pickedDate && pickedDate.length > 0) {
      const allFromDate = _events.filter((event) => {
        const selected_start = convertDate(pickedDate[0]),
          selected_end = convertDate(pickedDate[1]),
          event_end = parseInt(event.acf.ending_date),
          event_start = parseInt(event.acf.starting_date);

        return (
          //does the event start fall bewteen selected dates - true
          // STARTS INBETWEEN
          (event_start >= selected_start && event_start <= selected_end) ||
          // does the event end fall between the selected dates - true
          // ENDS INBETWEEN
          (event_end >= selected_start && event_end <= selected_end) ||
          // does the event start start happen before the select start AND does the event end happen after selected end - true
          // STARTS BEFORE AND ENDS AFTER
          (event_start <= selected_start && event_end >= selected_end)
        );
      });
      console.log("allFromDate", allFromDate);
      allFromDate.length > perPage ? setPageCount(Math.ceil(allFromDate.length / perPage)) : setPageCount(1);
      setCurrentPage(0);
      setFilteredEvents(allFromDate);
      setCurrentPageData([..._events.slice(offset, offset + perPage)]);
    } else {
      setFilteredEvents(events);
      displayEvents();
    }
  };
  const _filterEventsByDate = (events = []) => {
    if (pickedDate && pickedDate.length > 0) {
      const allFromDate = events.filter((event) => {
        const selected_start = convertDate(pickedDate[0]),
          selected_end = convertDate(pickedDate[1]),
          event_end = parseInt(event.acf.ending_date),
          event_start = parseInt(event.acf.starting_date);

        return (
          (event_start >= selected_start && event_start <= selected_end) ||
          (event_end >= selected_start && event_end <= selected_end) ||
          (event_start <= selected_start && event_end >= selected_end)
        );
      });
      return allFromDate;
    }
    return events;
  };
  const _filterEventsByCategory = (events = []) => {
    if (selectedCategory) {
      const allInCat = selectedCategory.map((option) =>
        events.filter((event, i) => event.event_category.includes(option.value)),
      );
      const allInCategory = allInCat.flat();
      return allInCategory;
    }
    return events;
  };
  const filterByCategory = (events) => {
    if (selectedCategory) {
      if (!selectedCategory.length) {
        setSelectedCategory(null);
      }
      const allInCat = selectedCategory.map((option) =>
        events.filter((event, i) => event.event_category.includes(option.value)),
      );
      const allInCategory = allInCat.flat();
      allInCategory.length > perPage ? setPageCount(Math.ceil(allInCategory.length / perPage)) : setPageCount(1);
      setCurrentPage(0);
      setFilteredEvents(allInCategory);
      setCurrentPageData([...filteredEvents.slice(offset, offset + perPage)]);
    }

    return events;
  };
  const getEventsInCategory = () => {
    console.log("get events in category");
    const _events = _filterEventsByDate(events);
    if (selectedCategory) {
      if (!selectedCategory.length) {
        setSelectedCategory(null);
      }
      const allInCat = selectedCategory.map((option) =>
        _events.filter((event, i) => event.event_category.includes(option.value)),
      );
      const allInCategory = allInCat.flat();
      allInCategory.length > perPage ? setPageCount(Math.ceil(allInCategory.length / perPage)) : setPageCount(1);
      console.log("allInCategory", allInCategory);
      setCurrentPage(0);
      setFilteredEvents(allInCategory);
      setCurrentPageData([...filteredEvents.slice(offset, offset + perPage)]);
    } else {
      setFilteredEvents(_events);
      displayEvents();
    }
  };

  const getSearchedEvents = () => {
    const _events = _filterEventsByDate(_filterEventsByCategory(events));
    const found =
      _events && _events.filter((event) => event.title.rendered.toLowerCase().includes(searchTerm.toLowerCase()));
    found.length > perPage ? setPageCount(Math.ceil(found.length / perPage)) : setPageCount(1);
    setCurrentPage(0);
    setFilteredEvents(found);
    setCurrentPageData([...found.slice(offset, offset + perPage)]);
  };

  const handleFavorites = (e) => {
    e.preventDefault();
    const evToAdd = e.target.value;
    const inIt = localStorageEvent.includes(evToAdd);
    // inIt
    // 	? (e.target.className = 'empty-hearth')
    // 	: (e.target.className = 'full-hearth empty-hearth');
    setLocalStorageEvent((prev) => (inIt ? prev.filter((val) => val != evToAdd) : [...prev, evToAdd]));
  };

  const styles = {
    card: {
      backgroundColor: "#F8EDDB",
      fontFamily: "FFMiloWebProRegular,sans-serif",
    },
    cardBody: {
      backgroundColor: "#F8EDDB",
      fontFamily: "FFMiloWebProRegular,sans-serif",
      padding: "0 25px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      fontWeight: 400,
      lineHeight: "1.4",
      color: "#494949",
      margin: 0,
      fontSize: ".85rem",
      position: "relative",
    },
    title: {
      color: "#2B4168",
      fontSize: "20px",
      fontFamily: "League Gothic, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
      padding: 0,
      lineHeight: "1.5",
    },
    location: {
      color: "#2B4168",
      fontFamily: "FFMiloWebProRegular,sans-serif",
    },
    dates: {
      fontWeight: 400,
      fontFamily: "FFMiloWebProRegular,sans-serif",
      color: "#494949",
      padding: 0,
      textRendering: "optimizeLegibility",
      marginBottom: "5px",
      // minHeight: '21px',
    },
    content: {
      color: "#494949",
      fontFamily: "FFMiloWebProRegular,sans-serif",
    },
    venue: {
      color: "#494949",
      marginBottom: "3px",
      fontFamily: "FFMiloWebProRegular,sans-serif",
      textTransform: "uppercase",
      fontSize: "14px",
      // minHeight: '19px',
    },
    button: {
      backgroundColor: "#2B4168",
      padding: "10px 30px",
      fontFamily: "FFMiloWebProRegular,sans-serif",
    },
    footer: {
      background: "none",
      border: "none",
      fontFamily: "FFMiloWebProRegular,sans-serif",
    },
    topBar: {
      backgroundColor: "#F8EDDB",
      padding: "1.5rem 1rem",
      with: "100%",
    },
    topBarTitle: {
      color: "#2B4168",
      textTransform: "uppercase",
      fontSize: "1.875rem",
      fontFamily: "League Gothic, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
    },
    datePicker: {
      border: "1px solid rgb(204, 204, 204)",
      padding: "2px 8px",
      backgroundColor: "#ffffff",
    },
    figCaption: {
      backgroundColor: "#ffffff",
      color: "#2B4168",
      fontFamily: "League Gothic, sans-serif",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "1.125rem",
      position: "absolute",
      // top: '10px',
      // left: '10px',
      padding: "10px",
      margin: "10px 0 0 10px",
    },
    loaderWrapper: {
      width: "100%",
      minHeight: "600px",
      background: "white",
      position: "relative",
      zIndex: 99999999,
    },
    loadingText: {
      color: "#07678a",
      fontFamily: "FFMiloWebProRegular,sans-serif",
      textAlign: "center",
    },
    nothingFound: {
      width: "100%",
      minHeight: "600px",
      color: "#07678a",
      fontFamily: "FFMiloWebProRegular,sans-serif",
      textAlign: "center",
    },
    app: {
      maxWidth: "80rem",
      width: "100%",
    },
  };

  return (
    <div id="root" style={styles.app} ref={rootRef}>
      <FilterSearchBar
        className="tw:mb-[40px]"
        categories={options}
        setSelectedCategory={setSelectedCategory}
        setPickedDate={setPickedDate}
        handleSearch={handleSearch}
      />
      {isLoading ? (
        <div style={styles.loaderWrapper} className="d-flex justify-content-center align-items-center flex-column">
          <Loader type="ThreeDots" color="#009BC6" height={100} width={100} timeout={30000} />
          <p style={styles.loadingText}>Loading events</p>
        </div>
      ) : (
        <FadeIn transitionDuration={1000}>
          <Row xs={1} md={2} xl={3} style={styles.fadeIn} className="g-0 mb-30">
            {filteredEvents.length > 0 ? (
              filteredEvents
                .slice(offset, offset + perPage)
                .map(
                  (
                    {
                      id,
                      title,
                      acf,
                      excerpt,
                      thumbnail,
                      featuredImage,
                      content,
                      tto_descriptions,
                      link,
                      tto_event_meta,
                      event_category_array,
                      eventImage,
                    },
                    index,
                  ) => {
                    const start = acf["starting_date"];
                    const end = acf["ending_date"];
                    const venue = acf["event_venue"]?.[0]?.post_title ?? acf["venue_name_manual"]?.trim();
                    const sizes = acf.single_header_images[0]?.image?.sizes;
                    const startFormatted = dayjs(start).isBefore(dayjs().add(1, "day"))
                      ? "Through"
                      : dayjs(start).format("MMM D") + " -";
                    const endFormatted = dayjs(end).format("MMM D");
                    const eventCategories = Object.keys(event_category_array ?? {}).map((eventKey, i) => (
                      <li className="event-cat-single" key={i}>
                        <a
                          href={event_category_array[eventKey][1]}
                          rel="follow"
                          title={event_category_array[eventKey][0]}
                        >
                          {event_category_array[eventKey][0]}
                        </a>
                      </li>
                    ));

                    return (
                      <CustomCard
                        key={title.rendered}
                        start={start === end ? endFormatted : startFormatted}
                        end={start === end ? "" : endFormatted}
                        eventImage={sizes ?? eventImage}
                        featuredImage={featuredImage}
                        title={parse(title.rendered)}
                        link={swapUrlOrigin(link, window.origin)}
                        venue={venue}
                        tto_event_meta={tto_event_meta}
                        eventCategories={eventCategories}
                        description={parse(content.rendered)}
                        //description={parse(
                        //  tto_descriptions.description_spanish
                        //    ? tto_descriptions.description_spanish
                        //    : excerpt.rendered,
                        //)}
                      />
                    );

                    return (
                      <Col key={title.rendered} className="p-0 rounded-0 eventCard mb-4">
                        <Card className=" mb-3 h-100" style={styles.card}>
                          <Figure className="position-relative">
                            <a href={link}>
                              <img
                                src={featuredImage ? featuredImage : thumbnail}
                                alt={title.render}
                                style={styles.figureImg}
                                className="card-img-top eventImg"
                              />
                            </a>

                            <button
                              className={localStorageEvent.includes(id.toString()) ? "full-hearth" : "empty-hearth"}
                              onClick={handleFavorites}
                              value={id}
                            />

                            <Figure.Caption className="position-absolute top-0 left-0" style={styles.figCaption}>
                              {startFormatted} {endFormatted}
                            </Figure.Caption>
                            {/*<div className="shareEventWrapper">*/}
                            {/*    <FacebookShareButton*/}
                            {/*        url={link}*/}
                            {/*        quote={title.rendered}*/}
                            {/*        hashtag="#tempetourism">*/}
                            {/*        <FacebookIcon size={36} />*/}
                            {/*    </FacebookShareButton>*/}

                            {/*    <EmailShareButton*/}
                            {/*        url={link}*/}
                            {/*        subject={parse(title.rendered)}*/}
                            {/*        separator=" "*/}
                            {/*        body={*/}
                            {/*            parse(title.rendered) +*/}
                            {/*            '\n' +*/}
                            {/*            tto_event_meta.venue +*/}
                            {/*            '\n' +*/}
                            {/*            tto_event_meta.date +*/}
                            {/*            '\n'*/}
                            {/*        }>*/}
                            {/*        <EmailIcon size={36} />*/}
                            {/*    </EmailShareButton>*/}
                            {/*</div>*/}
                          </Figure>

                          <Card.Body style={styles.cardBody}>
                            <a href={link}>
                              <Card.Title style={styles.title}>{parse(title.rendered)}</Card.Title>
                            </a>
                            <div style={styles.venue}>{tto_event_meta.venue ? tto_event_meta.venue : null}</div>
                            <div style={styles.dates}>{tto_event_meta.date_alt}</div>
                            <ul className="event-cats">{eventCategories}</ul>
                            <div style={styles.content}>
                              {parse(
                                tto_descriptions.description_spanish
                                  ? tto_descriptions.description_spanish
                                  : excerpt.rendered,
                              )}
                            </div>
                          </Card.Body>
                          <Card.Footer style={styles.footer}>
                            <a
                              className="btn border-0 rounded-0 text-white d-block mb-2 btn-details"
                              href={link}
                              style={styles.button}
                            >
                              Event Details
                            </a>
                          </Card.Footer>
                        </Card>
                      </Col>
                    );
                  },
                )
            ) : (
              <div style={styles.nothingFound} className=" d-flex align-items-center justify-content-center">
                No events found
              </div>
            )}
          </Row>
          {filteredEvents.length > 0 && (
            <Row className="d-flex justify-content-center text-center my-5 w-100 max-auto">
              <Col className="justify-content-center mx-auto d-flex">
                <CustomPagination
                  currentPage={currentPage}
                  pageCount={pageCount}
                  handlePrev={() => currentPage !== 0 && handlePageChange({ selected: currentPage - 1 })}
                  handleNext={() => currentPage + 1 < pageCount && handlePageChange({ selected: currentPage + 1 })}
                />
              </Col>
            </Row>
          )}
        </FadeIn>
      )}
      {/* <div id='storage'>{displayLocalData()}</div> */}
    </div>
  );
}

export default App;

// acf:
// ending_date: "20210926"
// ending_time: ""
// event_details: false
// event_hours: ""
// event_links: false
// event_venue: []
// phone: "(602) 286-3800"
// starting_date: "20210925"
// starting_time: ""
// venue_name_manual: ""
// website_url: "https://www.phoenixzoo.org/events/breakfast-with-the-animals-presented-by-nutella/"

// {
//         events.length &&
//           events.map((ev, i) => (

// ))}
